module.exports = __webpack_public_path__ + "img/think_lion_profile.2f66207f.png";